import {
  Button,
  Table,
  Tabs,
  Avatar,
  Badge,
  message,
  Modal,
  Slider,
  Spin,
  Upload,
  Form,
  Tooltip,
  Checkbox,
  Select,
  Tag,
  DatePicker,
  Card,
  Empty,
} from "antd";
import AvatarEditor from "react-avatar-editor";
import React, { useState, useEffect, useRef, useCallback } from "react";
import styled from "styled-components";
import TabPane from "antd/lib/tabs/TabPane";
import { dateInDetail, getKenyanDateTime, getMySqlDate } from "utils/Date";
import COLORS from "common/Colors";
import { Col, Row } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
  isEmpty,
  startCase,
  includes,
  flatMap,
  uniq,
  find,
  intersection,
} from "lodash";
import moment from "moment";
import { CALL_API } from "common/API";
import { LEAVE_ICON, STATUS_CODE } from "common/Constants";
import { setProfilePic, setRoleList, setUserList } from "redux/actions";
import {
  FileUnknownFilled,
  FolderFilled,
  InfoCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { bindActionCreators } from "redux";
import MainStyledDropzone from "../pages/Dropzone";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ViewMore from "organisms/ViewMore";
import LeaveTrackerChart from "./LeaveTracker";
import {
  getUserList,
  getClientid,
  getAllDepartmentList,
  getLocations,
  getRoleList,
  getSelectedDepartmentId,
  getUserInfo,
  getLeaveCategoryList,
  getMenuList,
  getUserRoleId,
} from "redux/selectors";
import Icon from "atoms/Icon";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import RejectReasonModal from "molecules/RejectReasonModal";
import EditEmployee from "organisms/EditEmployee";
import { useLocation } from "react-router-dom";
import download from "downloadjs";
import EditProfile from "organisms/EditProfile";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { ReactComponent as Edit } from "../assets/Edit_Pencil_01.svg";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import { useTranslation } from "react-i18next";
import TextArea from "antd/lib/input/TextArea";
import dayjs from "dayjs";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import ViewDocument from "reusableComponent/Popup/viewDocument";

const ProfileDetails = ({
  userList,
  ClientId,
  roleList,
  updateUserList,
  selectedDepartmentId,
  leaveCategoryList,
  saveProfilePic,
  userInfo,
  userRoleId,
  menuList,
  departmentList,
  saveRoleList,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  const [type, setType] = useState("");
  const [form] = Form.useForm();
  const [selectedYear, setSelectedYear] = useState(moment().year());
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [preview, setPreview] = useState(false);

  const folderList = [
    { name: "Identity information" },
    { name: "Final Records on Termination" },
  ];

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setType(searchParams.get("type"));
  }, []);

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const [filteruser, setFilterUser] = useState({});
  const [filterrole, setFilterRole] = useState([]);
  const [formvalues, setFormvalues] = useState({
    reasonforfileupload: "",
    reasonfortermination: "",
  });
  const [checkedClearance, setCheckedClearance] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]); // 👈 added

  useEffect(() => {
    const filteruser = userList?.find((item) => item?.userid === id);
    const filterrole = roleList?.find((item) =>
      filteruser?.roleid.includes(item?.roleId)
    );
    setFilterUser(filteruser);
    setFilterRole(filterrole);
  }, [userList]);

  const getFileIcon = (fileName) => {
    const ext = fileName?.split(".").pop()?.toLowerCase();

    const style = { fontSize: 40 };

    if (!ext) return <Icon name="word" style={style} />;

    if (ext === "pdf") return <Icon name="pdf" style={style} />;

    if (["jpg", "png", "jpeg", "svg"].includes(ext))
      return <Icon name="image" style={style} />;

    if (["xls", "csv", "xlsx"].includes(ext))
      return <Icon name="xl" style={style} />;

    if (["txt", "doc", "docx"].includes(ext))
      return <Icon name="word" style={style} />;

    if (["mp4", "avi", "mov"].includes(ext))
      return <Icon name="video" style={style} />;

    if (["ppt", "odp"].includes(ext)) return <Icon name="ppt" style={style} />;

    if (ext === "zip") return <Icon name="zip" style={style} />;

    return <FileUnknownFilled style={{ fontSize: 40 }} />;
  };

  const [activeTab, setActiveTab] = useState("0");
  const [btnLoader, togglebtnLoader] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoomin, setZoomin] = useState(1);
  const [rotatein, setRotatein] = useState(0);
  const [uniqueId, setUniqueId] = useState(generateUniqueId());
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openTerminationmodal, setOpenTerminationmodal] = useState(false);
  const [leaveList, setLeaveList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [leaveLoading, setLeaveLoading] = useState(false);
  const havingCancel = false;
  const [leaveDetails, setLeaveDetails] = useState({});
  const [displayDeclineReasonModal, toggleDeclineReasonModalVisibility] =
    useState(false);
  const [EmployeeDetails, setEmployeeDetails] = useState({});
  const [displayEditEmployeeModal, toggleEditEmployeeModal] = useState(false);
  const [leaveData, setLeaveData] = useState([]);
  const objectUrl = React.useMemo(
    () => (selectedImage ? URL.createObjectURL(selectedImage) : null),
    [selectedImage]
  );
  const [previewURL, setPreviewURL] = useState("");
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isLoadingDocuments, toggleLoadingDocuments] = useState(false);
  const [isDocumentUpload, setIsDocumentupload] = useState(false);
  const [previewType, setPrreviewType] = useState("");
  const [fileDetails, setFileDetails] = useState("");
  const [updateState, setUpdateState] = useState("");

  const editorRef = useRef(null);
  const settingNewCropImage = async () => {
    if (editorRef.current) {
      const canvas = editorRef.current.getImage();
      const croppedImage = canvas.toDataURL();
      return croppedImage;
    }
  };

  useEffect(() => {
    setEmployeeDetails({
      userid: filteruser?.userid || "",
      startdate: filteruser?.startdate || "",
      dateofbirth: filteruser?.dateofbirth || "",
      enddate: filteruser?.enddate || "",
      bandname: filteruser?.bandname || "",
      bandid: filteruser?.bandid || "",
      overtimestatus: filteruser?.overtimestatus || "",
      salary: filteruser?.salary || "",
      profileurl: filteruser?.profileurl || null,
      gender: filteruser?.gender || "",
      age: filteruser?.age || "",
      maritalstatus: filteruser?.maritalstatus || "",
      nationality: filteruser?.nationality || "",
      roleid: filteruser?.roleid || "",
      address: filteruser?.presentaddress || "",
      phoneno: filteruser?.phoneno || "",
      institutename: filteruser?.institutename || "",
      jobtitle: filteruser?.jobtitle || "",
      professionalsince: filteruser?.professionalsince || "",
      hireddate: filteruser?.hireddate || "",
      relevant: filteruser?.relevant || "",
      national_id: filteruser?.national_id || "",
      nssf: filteruser?.nssf || "",
      krapin: filteruser?.krapin || "",
      sharegnum: filteruser?.sharegnum || "",
      driverslicense: filteruser?.driverslicense || "",
      contract: filteruser?.contract || "",
      employeesponser: filteruser?.employeesponser || "",
      statusname: filteruser?.statusname || "",
      jobdescription: filteruser?.jobdescription || "",
      emergencycontactname: filteruser?.emergencycontactname || "",
      emergencycontactnumber: filteruser?.emergencycontactnumber || "",
      statusid: filteruser?.statusid || "",
      employementtype: filteruser?.employementtype || "",
      baselocationid: filteruser?.baselocationid || "",
      basedepartmentid: filteruser?.basedepartmentid || "",
      employeeid: filteruser?.employeeid || "",
      initial: filteruser?.initial || "",
      firstname: filteruser?.firstname || "",
      lastname: filteruser?.lastname || "",
      salutation: filteruser?.salutation || "",
      professionalcertification: filteruser?.professionalcertification
        ? filteruser?.professionalcertification
        : [],
      lastpromotionlevel: filteruser?.lastpromotionlevel || "",
      companyname: filteruser?.companyname || "",
      educationdetails: filteruser?.educationdetails || [],
      workexperience: filteruser?.workexperience || [],
      professionalcertifications: filteruser?.professionalcertifications
        ? filteruser?.professionalcertifications
        : [],
      practicaltrainings: filteruser?.practicaltrainings || [],
      lastpromotiondate: filteruser?.lastpromotiondate || "",
      probationstartdate: filteruser?.probationstartdate || "",
      probationenddate: filteruser?.probationenddate || "",
      contractstartdate: filteruser?.contractstartdate || "",
      contractenddate: filteruser?.contractenddate || "",
      reportingmanager: filteruser?.reportingmanager || "",
      isemployeeselfkpi: filteruser?.isemployeeselfkpi || false,
      employeenumber: filteruser?.employeenumber || "",
    });
  }, [filteruser]);

  const handleupload = async () => {
    const { code } = await CALL_API(
      `upload-identity/${ClientId}/${filteruser?.userid}`,
      "post",
      {
        name: fileDetails.name,
        type: fileDetails.type,
        content: fileDetails?.content,
        identityName: fileDetails?.identityName,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      message.success(t("Document uploaded"));
      fetchMasterData();
    } else {
      message.error(t("You can only upload files up to 10MB in size."));
    }
    setFileDetails("");
    setIsDocumentupload(false);
  };

  useEffect(() => {
    if (fileDetails !== "") {
      handleupload();
    }
  }, [fileDetails]);

  const tabTitles = [
    t("Employee Details"),
    t("Documents"),
    t("Leave Tracker"),
    t("Education Details"),
    t("Work Experience"),
  ];

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const wrokExperenceColumns = [
    {
      title: t("Company name"),
      dataIndex: "companyname",
      key: "companyname",
    },
    {
      title: t("Job Title"),
      dataIndex: "jobtitle",
      key: "jobtitle",
    },
    {
      title: t("From"),
      dataIndex: "fromdate",
      key: "fromdate",
      render: (fromdate, record) => {
        if (fromdate && record?.companyname) {
          return moment(fromdate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("To"),
      dataIndex: "todate",
      key: "todate",
      render: (todate, record) => {
        if (todate && record?.companyname) {
          return moment(todate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("Job Description"),
      dataIndex: "jobdescription",
      key: "jobdescription",
      className: "normal-column",
      render: (jobdescription) => {
        return <ViewMore value={jobdescription} />;
      },
    },
    {
      title: t("Relevant"),
      dataIndex: "relevant",
      key: "relevant",
    },
  ];

  const handlePreviewClickLeave = async (data) => {
    try {
      const preview = data?.fileName?.split(".")?.pop();
      setLoading(true);

      const { code, url } = await CALL_API(
        `document-list/${ClientId}`,
        "post",
        {
          user_leave_id: data?.user_leave_id,
          method: "file",
          userId: data?.userid,
        }
      );

      if (code === STATUS_CODE.SUCCESS) {
        if (["jpg", "jpeg", "png", "svg", "pdf"].includes(preview)) {
          setPreviewURL(url);
          setPreview(true);
        } else {
          download(url);
          setPreview(false);
        }
      } else {
        message.error("Preview failed. Try again.");
      }
    } catch (err) {
      console.log(err);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const LeaveApprovalColumns = [
    {
      title: t("Start Date"),
      dataIndex: "start_date",
      key: "start_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_start_date === "null" ||
          record.new_start_date === null ||
          record.new_start_date === ""
        ) {
          return moment(record.start_date).format("DD MMM YYYY");
        } else {
          return moment(record.new_start_date).format("DD MMM YYYY");
        }
      },
    },
    {
      title: t("End Date"),
      dataIndex: "end_date",
      key: "end_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_end_date === "null" ||
          record.new_end_date === "" ||
          record.new_end_date === null
        ) {
          return moment(record.end_date).format("DD MMM YYYY");
        } else {
          return moment(record.new_end_date).format("DD MMM YYYY");
        }
      },
    },
    {
      title: t("Leave Type"),
      dataIndex: "leave_category_name",
      key: "leave_category_name",
      width: "10%",
    },
    {
      title: t("Duration"),
      dataIndex: "number_of_days",
      key: "number_of_days",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_number_of_days === "null" ||
          record.new_number_of_days === null ||
          record.new_number_of_days === ""
        ) {
          return `${record.number_of_days} ${t("days")}`;
        } else {
          return `${record.new_number_of_days} ${t("days")}`;
        }
      },
    },
    {
      title: t("Attachment"),
      dataIndex: "fileName",
      key: "fileName",
      width: 150,
      render: (text, record) =>
        text ? (
          <a
            href="#"
            style={{ color: "#2d53da" }}
            className="text-wrap"
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClickLeave(record);
            }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: t("Reliever Name"),
      dataIndex: "relievername",
      key: "relievername",
      width: "10%",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: t("Description"),
      dataIndex: "reason",
      key: "reason",
      width: "30%",
      className: "normal-column",
      render: (reason) => {
        return (
          <>
            <ViewMore value={reason} />
          </>
        );
      },
    },
  ];

  // if (
  //   Menulist?.find(
  //     (item) => item?.key === "approvals" && item?.permission?.edit
  //   )
  // ) {
  //   LeaveApprovalColumns.push({
  //     title: t("Action"),
  //     dataIndex: "action",
  //     key: "action",
  //     render: (_, record) => (
  //       <>
  //         <StyledProfileDetails>
  //           <div className="leave_approval_actions">
  //             <ButtonOutlined
  //               onClick={() => {
  //                 setIsModalOpen(true);
  //                 viewLeave(record, true);
  //               }}
  //             >
  //               {t("Approve")}
  //             </ButtonOutlined>
  //             <ButtonOutlined
  //               onClick={() => {
  //                 toggleDeclineReasonModalVisibility(true);
  //                 viewLeave(record, true);
  //               }}
  //             >
  //               {t("Decline")}
  //             </ButtonOutlined>
  //           </div>
  //         </StyledProfileDetails>
  //       </>
  //     ),
  //   });
  // }

  const LeaveHistoryColumns = [
    {
      title: t("Start Date"),
      dataIndex: "start_date",
      key: "start_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_start_date === "null" ||
          record.new_start_date === "" ||
          record.new_start_date === null
        ) {
          return moment(record.start_date).format("DD MMM YYYY");
        } else {
          return moment(record.new_start_date).format("DD MMM YYYY");
        }
      },
    },
    {
      title: t("End Date"),
      dataIndex: "end_date",
      key: "end_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_end_date === "null" ||
          record.new_end_date === "" ||
          record.new_end_date === null
        ) {
          return moment(record.end_date).format("DD MMM YYYY");
        } else {
          return moment(record.new_end_date).format("DD MMM YYYY");
        }
      },
    },
    {
      title: t("Leave Type"),
      dataIndex: "leave_category_name",
      key: "leave_category_name",
      width: "10%",
    },
    {
      title: t("Duration"),
      dataIndex: "number_of_days",
      key: "number_of_days",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_number_of_days === "null" ||
          record.new_number_of_days === null ||
          record.new_number_of_days === ""
        ) {
          return `${record.number_of_days} ${t("days")}`;
        } else {
          return `${record.new_number_of_days} ${t("days")}`;
        }
      },
    },
    {
      title: t("Attachment"),
      dataIndex: "fileName",
      key: "fileName",
      width: 150,
      render: (text, record) =>
        text ? (
          <a
            href="#"
            style={{ color: "#2d53da" }}
            className="text-wrap"
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClickLeave(record);
            }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: t("Reliever Name"),
      dataIndex: "relievername",
      key: "relievername",
      width: "10%",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: t("Description"),
      dataIndex: "reason",
      key: "reason",
      width: "30%",
      className: "normal-column",
      render: (reason) => {
        return (
          <>
            <ViewMore value={reason} />
          </>
        );
      },
    },
  ];

  const EducationColumns = [
    {
      title: t("Institute Name"),
      dataIndex: "institutename",
      key: "institutename",
      width: "5%",
    },
    {
      title: t("From"),
      dataIndex: "fromdate",
      key: "fromdate",
      width: "5%",
      render: (fromdate, record) => {
        if (fromdate && record?.institutename && moment(fromdate).isValid()) {
          return moment(fromdate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("To"),
      dataIndex: "todate",
      key: "todate",
      width: "5%",
      render: (todate, record) => {
        if (todate && record?.institutename && moment(todate).isValid()) {
          return moment(todate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("Exam Body"),
      dataIndex: "exambody",
      key: "exambody",
      width: "5%",
    },
    {
      title: t("Awarded"),
      dataIndex: "awarded",
      key: "awarded",
      width: "5%",
    },
    {
      title: t("Attachment"),
      dataIndex: "attachment",
      key: "attachment",
      width: "5%",
      render: (attachment, record) => {
        const file = attachment?.[0];
        if (file?.name && file.name !== "-") {
          return (
            <button
              className="bg-transparent text-primary border-0"
              onClick={() => {
                setPrreviewType(file.name.split(".").pop());
                handlePreviewClick(
                  file.documentId,
                  "educationdetails",
                  file.name
                );
              }}
            >
              {file.name}
            </button>
          );
        } else {
          return "-";
        }
      },
    },
  ];

  const handlePreviewClick = async (id, type, document) => {
    const preview = document?.split(".")?.pop();
    toggleLoadingDocuments(true);
    const { code, url } = await CALL_API(`document-list/${ClientId}`, "post", {
      method: "preview-user-document",
      documentId: id,
      identityName: type,
      userId: filteruser?.userid,
    });
    if (code === STATUS_CODE.SUCCESS) {
      if (
        preview === "jpg" ||
        preview === "png" ||
        preview === "jpeg" ||
        preview === "svg" ||
        preview === "pdf"
      ) {
        setIsPreviewModalOpen(true);
        setPreviewURL(url);
      } else {
        download(url);
      }
    } else {
      message.error(t("Something went wrong!! Please try again."));
    }
    toggleLoadingDocuments(false);
  };

  const handlepreview = async (id, document, index) => {
    const terminatedkey = filteruser?.terminatedkey?.[index];
    const preview = document?.split(".")?.pop();
    toggleLoadingDocuments(true);
    const { code, url } = await CALL_API(
      `add-users/${ClientId}/?method=termination-file&userid=${id}&terminatedkey=${terminatedkey}`,
      "get",
      {}
    );
    if (code === STATUS_CODE.SUCCESS) {
      if (
        preview === "jpg" ||
        preview === "png" ||
        preview === "jpeg" ||
        preview === "svg" ||
        preview === "pdf"
      ) {
        setIsPreviewModalOpen(true);
        setPreviewURL(url);
      } else {
        download(url);
      }
    } else {
      message.error(t("Something went wrong!! Please try again."));
    }
    toggleLoadingDocuments(false);
  };

  const handleMenuClick = async (id, type, document) => {
    const preview = document?.split(".")?.pop();
    toggleLoadingDocuments(true);
    const { code, url } = await CALL_API(`document-list/${ClientId}`, "post", {
      method: "preview-identity-document",
      documentId: id,
      identityName: type,
      userId: filteruser?.userid,
    });
    if (code === STATUS_CODE.SUCCESS) {
      if (
        preview === "jpg" ||
        preview === "png" ||
        preview === "jpeg" ||
        preview === "svg" ||
        preview === "pdf"
      ) {
        setIsPreviewModalOpen(true);
        setPreviewURL(url);
      } else {
        download(url);
      }
    } else {
      message.error(t("Something went wrong!! Please try again."));
    }
    toggleLoadingDocuments(false);
  };

  const IdentityInfoList = [
    {
      type: "NSSF",
      details: filteruser?.nssf || "-",
      document: filteruser?.nssfDocument?.documentName || "-",
      documentid: filteruser?.nssfDocument?.documentId || "-",
    },
    {
      type: "National ID",
      details: filteruser?.national_id || "-",
      document: filteruser?.nationalidDocument?.documentName || "-",
      documentid: filteruser?.nationalidDocument?.documentId || "-",
    },
    {
      type: "KRA PIN",
      details: filteruser?.krapin || "-",
      document: filteruser?.krapinDocument?.documentName || "-",
      documentid: filteruser?.krapinDocument?.documentId || "-",
    },
    {
      type: "SHA Registration Number",
      details: filteruser?.sharegnum || "-",
      document: filteruser?.sharegnumDocument?.documentName || "-",
      documentid: filteruser?.sharegnumDocument?.documentId || "-",
    },
    // {
    //   type: "Driver’s License",
    //   details: filteruser?.driverslicense || "-",
    //   document: filteruser?.driverslicenseDocument?.documentName || "-",
    //   documentid: filteruser?.driverslicenseDocument?.documentId || "-",
    // },
    // {
    //   type: "Contract",
    //   details: filteruser?.contract || "-",
    //   document: filteruser?.contractDocument?.documentName || "-",
    //   documentid: filteruser?.contractDocument?.documentId || "-",
    // },
  ];

  const IdentityInfoColumns = [
    {
      title: t("Type"),
      dataIndex: "type",
      key: "type",
    },
    {
      title: t("Details"),
      dataIndex: "details",
      key: "details",
    },
    {
      title: t("Action"),
      dataIndex: "type",
      key: "type",
      render: (type, record) => {
        const hasDocument = record.document && record.document !== "-";
        return (
          <Upload
            showUploadList={false}
            customRequest={({ file, onSuccess }) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => {
                const base64Data = reader.result.split(",")[1];
                onSuccess();
                setFileDetails({
                  name: file.name,
                  type: file.type,
                  content: base64Data,
                  identityName:
                    type === "NSSF"
                      ? "nssfDocument"
                      : type === "KRA PIN"
                      ? "krapinDocument"
                      : type === "SHA Registration Number"
                      ? "sharegnumDocument"
                      : type === "Driver’s License"
                      ? "driverslicenseDocument"
                      : type === "Contract"
                      ? "contractDocument"
                      : "nationalidDocument",
                });
              };
              reader.onerror = (error) => {
                console.error("File read error:", error);
              };
            }}
            onChange={(info) => {
              if (info.file.status === "done") {
                if (info.fileList.length > 0) {
                  const file = info.fileList[0].originFileObj;
                  const reader = new FileReader();
                  reader.onload = async (event) => {
                    const base64Data = event.target.result;
                    setIsDocumentupload(true);
                  };
                  reader.readAsDataURL(file);
                }
              }
            }}
          >
            {hasDocument ? (
              <Edit style={{ cursor: "pointer" }} />
            ) : (
              <ButtonFilled>{t("Attach file")}</ButtonFilled>
            )}
          </Upload>
        );
      },
    },
    {
      title: t("Document"),
      dataIndex: "document",
      key: "document",
      render: (document, record) => {
        if (document !== "-") {
          return (
            <button
              className="bg-transparent text-primary border-0"
              onClick={() => {
                setPrreviewType(document?.split(".")?.pop());
                handleMenuClick(
                  record?.documentid,
                  record?.type === "NSSF"
                    ? "nssfDocument"
                    : record?.type === "KRA PIN"
                    ? "krapinDocument"
                    : record?.type === "SHA Registration Number"
                    ? "sharegnumDocument"
                    : record?.type === "Driver’s License"
                    ? "driverslicenseDocument"
                    : record?.type === "Contract"
                    ? "contractDocument"
                    : "nationalidDocument",
                  document
                );
              }}
            >
              {document}
            </button>
          );
        } else {
          return "-";
        }
      },
    },
  ];

  const ApproveOk = async (reason) => {
    return new Promise(async (resolve) => {
      await approveRejectCancelLeave(5, reason, havingCancel);
      resolve();
    }).catch((err) => console.log("[ApproveOk] Error-->", err));
  };

  const approveHandleCancel = () => {
    setIsModalOpen(false);
  };

  const approveHandleOk = () => {
    setLoading(true);
    ApproveOk();
  };

  const viewLeave = (leaveObject) => {
    setLeaveDetails({ ...leaveObject });
  };

  const closeDeclineReasonModal = async (reason) => {
    if (reason) await approveRejectCancelLeave("6", reason);
    toggleDeclineReasonModalVisibility(false);
  };

  const approveRejectCancelLeave = async (
    statusId,
    declined_reason = "",
    is_leave_cancel_request
  ) => {
    return new Promise(async (resolve) => {
      const payload = {
        userid: leaveDetails?.userid,
        departmentId: selectedDepartmentId,
        user_leave_id: leaveDetails?.user_leave_id,
        status_id: statusId.toString(),
        declined_reason,
        is_cancel_request:
          leaveDetails.having_cancel_request === "1" ? true : false,
        start_date: leaveDetails?.new_start_date
          ? getMySqlDate(leaveDetails?.new_start_date)
          : getMySqlDate(leaveDetails?.start_date),
        end_date: leaveDetails?.new_end_date
          ? getMySqlDate(leaveDetails?.new_end_date)
          : getMySqlDate(leaveDetails?.end_date),
      };
      const { code } = await CALL_API(
        `approve-reject-cancel-leave/${ClientId}`,
        "post",
        {
          userid: leaveDetails?.userid,
          departmentId: selectedDepartmentId,
          user_leave_id: leaveDetails?.user_leave_id,
          status_id: statusId.toString(),
          declined_reason,
          is_cancel_request:
            leaveDetails.having_cancel_request === "1" ? true : false,
          start_date: leaveDetails?.new_start_date
            ? getMySqlDate(leaveDetails?.new_start_date)
            : getMySqlDate(leaveDetails?.start_date),
          end_date: leaveDetails?.new_end_date
            ? getMySqlDate(leaveDetails?.new_end_date)
            : getMySqlDate(leaveDetails?.end_date),
        }
      );

      if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
        message.error(t("Oops!! something went wrong."));
      } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
        message.error(t("Invalid payload. Please enter correct data."));
      } else if (code === STATUS_CODE.RECORD_EXIST) {
        message.error(t("Leave already exist."));
      } else if (code === STATUS_CODE.SUCCESS) {
        message.success(
          statusId?.toString() === "5"
            ? t("Your leave application has been Approved.")
            : statusId?.toString() === "6"
            ? t("Your leave application has been Declined.")
            : ""
        );
        getLeaveList();
        // Call webhook API
        // try {
        //   await fetch(`${N8N_URL}foresyts-approval-check`, {
        //     method: "POST",
        //     headers: { "Content-Type": "application/json" },
        //     body: JSON.stringify(payload),
        //   });
        // } catch (error) {
        //   console.log("[Webhook] Error:", error);
        // }
      }
      resolve();
      setLoading(false);
      setIsModalOpen(false);
    });
  };

  const LeaveApprovalData = leaveList.filter((val) => {
    if (
      val?.status_id === "4" ||
      (val?.status_id === "5" && val?.having_cancel_request === "1")
    ) {
      return val;
    }
  });

  const LeaveHistoryData = leaveList.filter((val) => {
    if (
      val?.status_id === "5" &&
      (val?.having_cancel_request === "0" || val?.having_cancel_request === "")
    ) {
      return val;
    }
  });

  const getLeaveList = useCallback(
    async (startdate, enddate) => {
      setLeaveLoading(true);
      const { leaves = [] } = await CALL_API(`leave-list/${ClientId}`, "post", {
        status_id: "",
        department_id: [""],
        // selected_role_id: 2,
        start_date: startdate,
        end_date: enddate,
        user_id: id,
      });
      const filteredLeaves = leaves.filter((item) => item.userid === id);
      setLeaveList(filteredLeaves.reverse());
      setLeaveLoading(false);
    },
    [ClientId, selectedDepartmentId, id]
  );

  useEffect(() => {
    const currentYear = moment().year();
    const startDate = moment(currentYear, "YYYY")
      .startOf("year")
      .format("YYYY-MM-DD");
    const endDate = moment(currentYear, "YYYY")
      .endOf("year")
      .format("YYYY-MM-DD");
    getLeaveList(startDate, endDate);
  }, [getLeaveList]);

  const getUserLeaveData = async () => {
    setLoading(true);
    try {
      const response = await CALL_API(
        `employee-leave-details/${ClientId}`,
        "post",
        {
          year: dateInDetail(getKenyanDateTime()).year,
          userId: id,
        }
      );
      if (!isEmpty(response)) {
        setLeaveData(response);
      }
    } catch (error) {
      console.error("Error fetching user leave data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserLeaveData();
  }, [ClientId]);

  const breadStyle = { color: "#636980", cursor: "pointer" };

  const breadcrumbs = [
    <label key="2" style={breadStyle} onClick={() => history.goBack()}>
      {t("People")}
    </label>,
    <Typography key="3" color="text.primary">
      {filteruser?.fullname}
    </Typography>,
  ];

  const fetchMasterData = async (fetch_master_data) => {
    const { code, userList, roleList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      { fetch_master_data }
    );
    if (code === STATUS_CODE.SUCCESS) {
      saveRoleList(roleList);
      updateUserList(userList);
      let profileUpdate = userList?.filter(
        (val) => val?.userid === userInfo.userid
      );
      if (profileUpdate?.length !== 0) {
        saveProfilePic(profileUpdate[0]?.profileurl);
      }
    }
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 20,
    showSizeChanger: false,
  };

  const { getPermissionById } = queryKeys;
  const { key, url } = getPermissionById(ClientId, filteruser?.roleid);
  const { data } = useFetch(key, url);

  const handlepremissionsubmit = async (status) => {
    const { code } = await CALL_API(
      `owner-roles/${ClientId}/${filteruser?.roleid}`,
      "patch",
      {
        rolename: data?.response?.data[0]?.roleName,
        location: data?.response?.data[0]?.locationId,
        menuList: data?.response?.data[0]?.menuList,
        rolestatus: status === "1" ? "Enabled" : "Disabled",
        department: data?.response?.data[0]?.department,
        statusId: status,
      }
    );
    if (STATUS_CODE.SUCCESS === code) {
      fetchMasterData();
    }
  };

  const deleteEmployee = async (
    reason,
    fileObj,
    fileName,
    notes,
    finalclearance
  ) => {
    togglebtnLoader(true);
    handlepremissionsubmit("0");
    await CALL_API(`add-users/${ClientId}`, "delete", {
      user_id: id,
      status_id: "0",
      status_name: "inactive",
      terminated_date: dayjs(),
      terminatereason: reason,
      objectKey: fileObj,
      terminatefilename: fileName,
      notes: notes,
      finalclearance: finalclearance,
      terminatedby: userInfo?.name || "",
    });
    setFormvalues("");
    togglebtnLoader(false);
    message.success(
      t(
        "This Employee has been terminated. This employee will be removed within a maximum of 8 hours"
      )
    );
    history.goBack();
  };

  const reinstateEmployee = async () => {
    togglebtnLoader(true);
    handlepremissionsubmit("1");
    await CALL_API(`add-users/${ClientId}`, "delete", {
      user_id: id,
      status_id: "1",
      status_name: "active",
      terminated_date: filteruser?.terminateddate || "",
      terminatereason: filteruser?.terminatedreason || "",
      objectKey: filteruser?.terminatedkey || [],
      terminatefilename: filteruser?.terminatedfilename || [],
      notes: filteruser?.notes || "",
      finalclearance: filteruser?.finalclearance || [],
      terminatedby: filteruser?.terminatedby || "",
    });
    togglebtnLoader(false);
    message.success(t("This Employee has been reinstate"));
    history.goBack();
  };

  const confirmReinstateEmployee = () => {
    Modal.confirm({
      title: "Confirm reinstate",
      content: "Are you sure you want to reinstate this employee?",
      okText: "Yes",
      cancelText: "No",
      centered: true,
      onOk() {
        reinstateEmployee(); // your existing API/function call
      },
      onCancel() {
        console.log("reinstate cancelled");
      },
    });
  };

  function generateUniqueId() {
    const usedIds = [];
    let uniqueId = "";
    while (uniqueId.length !== 6) {
      const randomNumber = Math.floor(Math.random() * 900000) + 100000;
      if (!usedIds.includes(randomNumber.toString())) {
        usedIds.push(randomNumber.toString());
        uniqueId += randomNumber.toString();
      }
    }
    return uniqueId;
  }

  let userId = id;
  let splitUserId = userId.split("@");
  let userIdWithoutDomain = splitUserId[0];
  let updatedUserId = userIdWithoutDomain + uniqueId;

  const handleUploadProfile = async () => {
    let x = await settingNewCropImage();
    try {
      setUniqueId(generateUniqueId());
      const obj = {
        userid: updatedUserId,
        filetype: selectedImage.type,
        content: x,
        filename: uniqueId,
        emailid: id,
      };
      setConfirmLoading(true);
      const { code } = await CALL_API(
        `profile-upload/${ClientId}`,
        "post",
        obj
      );
      if (code === "SUCCESS") {
        setShowImageModal(false);
        fetchMasterData();
        setConfirmLoading(false);
      }
      setConfirmLoading(false);
    } catch (error) {
      console.error("[handleUploadProfile] Error -->", error);
      setConfirmLoading(false);
    }
  };

  const WorkInfoDetails = [
    { data: t("Overtime Eligible"), value: filteruser?.overtimestatus || "-" },
    { data: t("Company Name"), value: filteruser?.companyname || "-" },
    {
      data: t("Last Promotion Date"),
      value:
        !filteruser?.lastpromotiondate ||
        filteruser?.lastpromotiondate === "Invalid date"
          ? "-"
          : filteruser?.lastpromotiondate,
    },
    {
      data: t("Last Promotion Level"),
      value: filteruser?.lastpromotionlevel || "-",
    },
    {
      data: t("Professional Since"),
      value: filteruser?.professionalsince
        ? moment(filteruser?.professionalsince).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: t("Hired Date"),
      value: filteruser?.hireddate
        ? moment(filteruser?.hireddate).format("DD-MM-YYYY")
        : "-",
    },
    { data: t("Job Title"), value: filteruser?.jobtitle || "-" },
    {
      data: t("Status"),
      value: filteruser?.statusid === "1" ? t("Active") : t("In Active") || "-",
    },
    { data: t("Employee Sponsor"), value: filteruser?.employeesponser || "-" },
    { data: t("Employment Type"), value: filteruser?.employementtype || "-" },
  ];

  if (filteruser?.employementtype === "Probation") {
    WorkInfoDetails.push(
      {
        data: t("Probation Start Date"),
        value: filteruser?.probationstartdate
          ? moment(filteruser?.probationstartdate).format("DD-MM-YYYY")
          : "-",
      },
      {
        data: t("Probation End Date"),
        value: filteruser?.probationenddate
          ? moment(filteruser?.probationenddate).format("DD-MM-YYYY")
          : "-",
      }
    );
  }

  if (filteruser?.employementtype === "Contract") {
    WorkInfoDetails.push(
      {
        data: t("Contract Start Date"),
        value: filteruser?.contractstartdate
          ? moment(filteruser?.contractstartdate).format("DD-MM-YYYY")
          : "-",
      },
      {
        data: t("Contract End Date"),
        value: filteruser?.contractenddate
          ? moment(filteruser?.contractenddate).format("DD-MM-YYYY")
          : "-",
      },

      {
        data: t("Employee self KPI Planning"),
        value: filteruser?.isemployeeselfkpi ? t("Yes") : t("No"),
      }
    );
  }

  const personalDet = [
    { data: t("Salutation"), value: filteruser?.salutation || "-" },
    { data: t("Initial"), value: filteruser?.initial || "-" },
    { data: t("First Name"), value: filteruser?.firstname || "-" },
    { data: t("Last Name"), value: filteruser?.lastname || "-" },
    { data: t("Employee ID"), value: filteruser?.employeeid || "-" },
    { data: t("Employee Number"), value: filteruser?.employeenumber || "-" },
    { data: t("Email ID"), value: filteruser?.userid || "-" },
    {
      data: t("Date Of Birth"),
      value: filteruser?.dateofbirth
        ? moment(filteruser?.dateofbirth).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: t("Marital Status"),
      value: filteruser?.maritalstatus
        ? filteruser?.maritalstatus.charAt(0).toUpperCase() +
          filteruser?.maritalstatus.slice(1)
        : "-",
    },
    { data: t("NSSF"), value: filteruser?.nssf || "-" },
    { data: t("National ID"), value: filteruser?.national_id || "-" },
    { data: t("kra_pin"), value: filteruser?.krapin || "-" },
    { data: t("sha_registration_number"), value: filteruser?.sharegnum || "-" },
    // { data: t("drivers_license"), value: filteruser?.driverslicense || "-" },
    // { data: t("contract"), value: filteruser?.contract || "-" },
    { data: t("Age"), value: filteruser?.age || "-" },
    {
      data: t("Country"),
      value: filteruser?.nationality
        ? filteruser?.nationality.charAt(0).toUpperCase() +
          filteruser?.nationality.slice(1)
        : "-",
    },
    {
      data: t("Gender"),
      value: filteruser?.gender
        ? filteruser?.gender.charAt(0).toUpperCase() +
          filteruser?.gender.slice(1)
        : "-",
    },
    { data: t("Address"), value: filteruser?.presentaddress || "-" },
    { data: t("Phone No"), value: filteruser?.phoneno || "-" },
    {
      data: t("Emergency Contact Name"),
      value: filteruser?.emergencycontactname || "-",
    },
    {
      data: t("Emergency Contact Number"),
      value: filteruser?.emergencycontactnumber || "-",
    },
    {
      data: t("Reporting Manager"),
      value:
        userList?.find((val) => val?.userid === filteruser?.reportingmanager)
          ?.fullname || "-",
    },
  ];

  const PersenalcertificationColumns = [
    {
      title: t("Certification Type"),
      dataIndex: "certificationtype",
      key: "certificationtype",
      width: "5%",
    },
    {
      title: t("From"),
      dataIndex: "fromdate",
      key: "fromdate",
      width: "5%",
      render: (fromdate, record) => {
        if (
          fromdate &&
          record?.certificationtype &&
          moment(fromdate).isValid()
        ) {
          return moment(fromdate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("To"),
      dataIndex: "todate",
      key: "todate",
      width: "5%",
      render: (todate, record) => {
        if (todate && record?.certificationtype && moment(todate).isValid()) {
          return moment(todate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("Remarks"),
      dataIndex: "remarks",
      key: "remarks",
      width: "5%",
    },
    {
      title: t("Attachment"),
      dataIndex: "attachment",
      key: "attachment",
      width: "5%",
      render: (attachment, record) => {
        const file = attachment?.[0];
        if (file?.name && file?.name !== "-") {
          return (
            <button
              className="bg-transparent text-primary border-0"
              onClick={() => {
                setPrreviewType(file.name.split(".").pop());
                handlePreviewClick(
                  file.documentId,
                  "professionalcertifications",
                  file.name
                );
              }}
            >
              {file.name}
            </button>
          );
        } else {
          return "-";
        }
      },
    },
  ];

  const PracticalTrainingColumns = [
    {
      title: t("Organisation Name"),
      dataIndex: "organisationname",
      key: "organisationname",
    },
    {
      title: t("From"),
      dataIndex: "fromdate",
      key: "fromdate",
      render: (fromdate, record) => {
        if (
          fromdate &&
          record?.organisationname &&
          moment(fromdate).isValid()
        ) {
          return moment(fromdate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("To"),
      dataIndex: "todate",
      key: "todate",
      render: (todate, record) => {
        if (todate && record?.organisationname && moment(todate).isValid()) {
          return moment(todate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("Position Held"),
      dataIndex: "positionheld",
      key: "positionheld",
      render: (positionheld) => (positionheld ? positionheld : "-"),
    },
    {
      title: t("Nature of work & Tasks performed or completed"),
      dataIndex: "tasksperformed",
      key: "tasksperformed",
      className: "normal-column",
      render: (tasksperformed) => {
        return <ViewMore value={tasksperformed} count={20} />;
      },
    },
  ];

  const handleDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    setSelectedImage(file);
  };
  const CropPopModal = () => {
    setShowImageModal(true);
  };
  const CloseImageModal = async () => {
    setShowImageModal(false);
    setZoomin(1);
    setRotatein(0);
  };
  const resetSelectedImage = () => {
    setSelectedImage(null);
  };
  const showModal = () => {
    setOpenTerminationmodal(true);
  };
  const handleTermination = () => {
    setOpenTerminationmodal(true);
  };
  const handleOk = () => {
    handleTermination();
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setCheckedClearance([]);
    setAttachmentList([]);
    handleCanceltermination();
  };

  // 👇 updated to also reset attachmentList
  const handleCanceltermination = () => {
    form.resetFields();
    setCheckedClearance([]);
    setAttachmentList([]);
    setOpenTerminationmodal(false);
  };

  const role = roleList?.filter((item) =>
    filteruser?.roleid?.[0]?.includes(item?.roleId)
  );

  const concatenatedArray = flatMap(filteruser?.userdepartmentid);
  const uniqueArray = uniq(concatenatedArray);
  const department = departmentList?.filter(
    (item) => filteruser?.basedepartmentid === item?.department_id
  );

  const filterrolelist = roleList?.filter((val) =>
    val?.roleId.includes(filteruser?.roleid)
  );
  const filterlocationid = filterrolelist[0]?.locationId;

  const filterleaves = [];
  leaveCategoryList?.forEach((item) => {
    if (item?.locationId?.length > 0) {
      if (intersection(item?.locationId, filterlocationid).length > 0) {
        filterleaves.push(item);
      }
    }
  });

  const filteredCategoriesbygender =
    filteruser?.gender?.toLowerCase() === "male"
      ? filterleaves?.filter(
          (item) => item.eligible?.toLowerCase() !== "female"
        )
      : filterleaves?.filter((item) => item.eligible?.toLowerCase() !== "male");

  const cursorstyle = { cursor: "pointer" };
  const iconStyle = { fontSize: "18px", color: "#fff", paddingBottom: "3px" };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormvalues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (value, name) => {
    setFormvalues((prev) => ({ ...prev, [name]: value }));
  };

  const handleDocumentSubmit = async (file) => {
    try {
      const initPayload = {
        filename: file.name,
        type: file.type,
      };

      const res = await CALL_API(
        `upload-document/${ClientId}?endpoint=documents`,
        "post",
        initPayload
      );

      if (res?.code !== STATUS_CODE.SUCCESS) {
        throw new Error("Failed to get upload url");
      }

      const uploadUrl = res?.url;
      const key = res?.key;

      if (!uploadUrl) throw new Error("Upload URL missing");

      const putRes = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type || "application/octet-stream",
        },
        body: file,
      });

      if (!putRes.ok) throw new Error("Upload failed");

      return key;
    } catch (err) {
      message.error(t("File upload failed"));
      return "";
    }
  };

  const handleSubmitForm = async (values) => {
    console.log("terminationdata--", values);
    togglebtnLoader(true);

    const fileList = values?.attachment || [];

    let uploadedKeys = [];
    let fileNames = [];

    if (fileList.length === 0) {
      uploadedKeys = [];
      fileNames = [];
    }

    if (fileList.length > 0) {
      const videoTypes = [
        "video/mp4",
        "video/mpeg",
        "video/quicktime",
        "video/x-msvideo",
        "video/x-ms-wmv",
        "video/webm",
        "video/ogg",
      ];

      for (let file of fileList) {
        const fileObj = file.originFileObj;

        if (!fileObj) continue;

        if (
          videoTypes.includes(fileObj.type) ||
          fileObj.type?.startsWith("video/")
        ) {
          message.error(`${fileObj.name} - Video files are not allowed`);
          togglebtnLoader(false);
          return;
        }

        const key = await handleDocumentSubmit(fileObj);

        if (!key) {
          togglebtnLoader(false);
          return;
        }

        uploadedKeys.push(key);
        fileNames.push(fileObj.name);
      }
    }

    const clearance =
      values?.clearance?.filter((item) => item !== "others") || [];

    const otherTags = Array.isArray(values?.otherTags) ? values.otherTags : [];

    deleteEmployee(
      values?.terminatereason,
      uploadedKeys,
      fileNames,
      values?.notes,
      [...clearance, ...otherTags]
    );

    // togglebtnLoader(false);
  };

  const canEditLeaveCount = Boolean(
     Menulist?.find(
                              (item) =>
                                item?.key === "employee" &&
                                item?.permission.edit
                            ) 
  );

  return (
    <>
      {!updateState && (
        <>
          <StyledProfileDetails>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
            <Row className="Broker_profile_flex">
              <Col xl={8}>
                <Col className="styled_col">
                  {type === "hr" && (
                    <>
                      {filteruser?.profileurl === null ? (
                        <Badge
                          count={
                            Menulist?.find(
                              (item) =>
                                item?.key === "HRResources" &&
                                item?.subMenu?.find(
                                  (subItem) =>
                                    subItem?.key === "team" &&
                                    subItem?.permission.edit
                                )
                            ) && (
                              <Icon
                                style={cursorstyle}
                                name="profileEdit"
                                className="camera_select_icon"
                                onClick={CropPopModal}
                              />
                            )
                          }
                        >
                          <StyledAvatar size="default">
                            {startCase(filteruser.fullname).charAt(0)}
                          </StyledAvatar>
                        </Badge>
                      ) : (
                        <Badge
                          count={
                            Menulist?.find(
                              (item) =>
                                item?.key === "HRResources" &&
                                item?.subMenu?.find(
                                  (subItem) =>
                                    subItem?.key === "team" &&
                                    subItem?.permission.edit
                                )
                            ) && (
                              <Icon
                                style={cursorstyle}
                                name="profileEdit"
                                className="camera_select_icon"
                                onClick={CropPopModal}
                              />
                            )
                          }
                        >
                          <StyledAvatar
                            src={filteruser?.profileurl}
                            size="default"
                            className="StyledImage"
                          />
                        </Badge>
                      )}
                    </>
                  )}
                  {type === "manage" && (
                    <>
                      {filteruser?.profileurl === null ? (
                        <Badge
                          count={
                            Menulist?.find(
                              (item) =>
                                item?.key === "employee" &&
                                item?.permission.edit
                            ) && (
                              <Icon
                                style={cursorstyle}
                                name="profileEdit"
                                className="camera_select_icon"
                                onClick={CropPopModal}
                              />
                            )
                          }
                        >
                          <StyledAvatar size="default">
                            {startCase(filteruser.fullname).charAt(0)}
                          </StyledAvatar>
                        </Badge>
                      ) : (
                        <Badge
                          count={
                            Menulist?.find(
                              (item) =>
                                item?.key === "employee" &&
                                item?.permission.edit
                            ) && (
                              <Icon
                                style={cursorstyle}
                                name="profileEdit"
                                className="camera_select_icon"
                                onClick={CropPopModal}
                              />
                            )
                          }
                        >
                          <StyledAvatar
                            src={filteruser?.profileurl}
                            size="default"
                            className="StyledImage"
                          />
                        </Badge>
                      )}
                    </>
                  )}

                  <div className="w-100 bg-red d-flex justify-content-between">
                    <div>
                      <div className="px-3">
                        <div>
                          <p className="m-0 broker_tittle">
                            {filteruser?.fullname || "-"}
                          </p>
                        </div>
                        <div className="contact_details">
                          <p className="common_color_style">
                            {t("Job Title")}:{" "}
                            <span className="common_color_style">
                              {filteruser?.jobtitle || "-"}
                            </span>
                          </p>
                        </div>
                        <div className="contact_details">
                          <div className="common_color_style">
                            {t("Department")}:{" "}
                          </div>
                          <div className="w-100 common_color_style text-wrap">
                            {department
                              .map((dept) => dept.department_name)
                              .join(",")}
                          </div>
                        </div>
                        <div className="contact_details">
                          <p className="common_color_style">
                            {t("Employee ID")}:{" "}
                            <span className="common_color_style">
                              {filteruser?.employeeid || "-"}
                            </span>
                          </p>
                        </div>
                        <p className="common_color_style">
                          {t("Email ID")}:{" "}
                          <span className="common_color_style">
                            {id || "-"}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              </Col>
              {type === "hr" && (
                <Col xl={4} className="credit_box_container">
                  {filteruser?.statusid === "0" && (
                    <>
                      <div
                        style={{
                          width: "auto",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#FCD8DB",
                            width: "max-content",
                            borderRadius: "5px",
                          }}
                          className="mb-2 p-2"
                        >
                          Terminated on{" "}
                          <span className="text-danger">
                            {filteruser?.terminateddate
                              ? moment(filteruser?.terminateddate).format(
                                  "Do MMM YYYY"
                                )
                              : "-"}
                          </span>
                          <br />
                          by{" "}
                          <span className="text-danger">
                            {filteruser?.terminatedby}
                          </span>
                        </div>

                        <div
                          style={{
                            backgroundColor: "#D8F8FC",
                            width: "max-content",
                            borderRadius: "5px",
                          }}
                          className=" p-2"
                        >
                          Final Clearance:{" "}
                          <span>
                            {filteruser?.finalclearance?.join(", ") || "-"}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end align-items-center gap-2">
                        <ButtonOutlined
                          className="mx-0"
                          onClick={() => {
                            Modal.warning({
                              title: "Terminate Reason",
                              content: filteruser?.terminatedreason || "-",
                            });
                          }}
                        >
                          {t("Terminate Reason")}
                        </ButtonOutlined>
                        <ButtonOutlined
                          className="mx-0"
                          onClick={() => {
                            Modal.warning({
                              title: "Notes",
                              content: filteruser?.notes || "-",
                            });
                          }}
                        >
                          {t("Notes")}
                          <ArrowOutwardIcon style={{ fontSize: "12px" }} />
                        </ButtonOutlined>
                      </div>
                    </>
                  )}
                  {Menulist?.find(
                    (item) =>
                      item?.key === "HRResources" &&
                      item?.subMenu?.find(
                        (subItem) =>
                          subItem?.key === "team" && subItem?.permission.delete
                      )
                  ) && (
                    <>
                      {filteruser?.statusid?.toString() === "1" && (
                        <div>
                          <ButtonOutlined className="mx-0" onClick={showModal}>
                            <Icon
                              name="terminate"
                              className="Remove_select_icon"
                            />
                            {t("Terminate")}
                          </ButtonOutlined>
                        </div>
                      )}
                      {filteruser?.statusid?.toString() === "0" && (
                        <div>
                          <ButtonOutlined
                            className="mx-0"
                            onClick={confirmReinstateEmployee}
                            loading={btnLoader}
                          >
                            {t("Reinstate")}
                          </ButtonOutlined>
                        </div>
                      )}
                    </>
                  )}
                </Col>
              )}
              {type === "manage" && (
                <Col xl={4} className="credit_box_container">
                  {filteruser?.statusid === "0" && (
                    <>
                      <div
                        style={{
                          width: "auto",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#FCD8DB",
                            width: "max-content",
                            borderRadius: "5px",
                          }}
                          className="mb-2 p-2"
                        >
                          Terminated on{" "}
                          <span className="text-danger">
                            {filteruser?.terminateddate
                              ? moment(filteruser?.terminateddate).format(
                                  "Do MMM YYYY"
                                )
                              : "-"}
                          </span>
                          <br />
                          by{" "}
                          <span className="text-danger">
                            {filteruser?.terminatedby}
                          </span>
                        </div>

                        <div
                          style={{
                            backgroundColor: "#D8F8FC",
                            width: "max-content",
                            borderRadius: "5px",
                          }}
                          className=" p-2"
                        >
                          Final Clearance:{" "}
                          <span>
                            {filteruser?.finalclearance?.join(", ") || "-"}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end align-items-center gap-2">
                        <ButtonOutlined
                          className="mx-0"
                          onClick={() => {
                            Modal.warning({
                              title: "Terminate Reason",
                              content: filteruser?.terminatedreason || "-",
                            });
                          }}
                        >
                          {t("Terminate Reason")}
                        </ButtonOutlined>
                        <ButtonOutlined
                          className="mx-0"
                          onClick={() => {
                            Modal.warning({
                              title: "Notes",
                              content: filteruser?.notes || "-",
                            });
                          }}
                        >
                          {t("Notes")}
                          <ArrowOutwardIcon style={{ fontSize: "12px" }} />
                        </ButtonOutlined>
                      </div>
                    </>
                  )}
                  {Menulist?.find(
                    (item) =>
                      item?.key === "employee" && item?.permission.delete
                  ) && (
                    <>
                      {filteruser?.statusid?.toString() === "1" && (
                        <div>
                          <ButtonOutlined className="mx-0" onClick={showModal}>
                            <Icon
                              name="terminate"
                              className="Remove_select_icon"
                            />
                            {t("Terminate")}
                          </ButtonOutlined>
                        </div>
                      )}
                      {filteruser?.statusid?.toString() === "0" && (
                        <div>
                          <ButtonOutlined
                            className="mx-0"
                            onClick={confirmReinstateEmployee}
                            loading={btnLoader}
                          >
                            {t("Reinstate")}
                          </ButtonOutlined>
                        </div>
                      )}
                    </>
                  )}
                </Col>
              )}
            </Row>

            <Tabs
              defaultActiveKey={activeTab}
              className="mt-3"
              onChange={handleTabChange}
            >
              {tabTitles.map((title, index) => (
                <TabPane tab={title} key={index.toString()}>
                  {activeTab === "0" && (
                    <>
                      <div className="mb-2 d-flex justify-content-between align-items-center">
                        <p className="employee_detail_headings mb-0">
                          {t("Work Information")}:
                        </p>
                        {type === "manage" &&
                          Menulist?.find(
                            (item) =>
                              item?.key === "employee" && item?.permission.edit
                          ) && (
                            <ButtonFilled
                              className="px-1"
                              onClick={() => setUpdateState("basic")}
                            >
                              <BorderColorIcon style={iconStyle} />
                            </ButtonFilled>
                          )}{" "}
                        {type === "hr" &&
                          Menulist?.find(
                            (item) =>
                              item?.key === "HRResources" &&
                              item?.subMenu?.find(
                                (subItem) =>
                                  subItem?.key === "team" &&
                                  subItem?.permission.edit
                              )
                          ) && (
                            <ButtonFilled
                              className="px-1"
                              onClick={() => setUpdateState("basic")}
                            >
                              <BorderColorIcon style={iconStyle} />
                            </ButtonFilled>
                          )}
                      </div>
                      <Row className="employee_work_info_box">
                        {WorkInfoDetails.map((data, index) => (
                          <Col xs={12} lg={6} key={index}>
                            <StyledRow className="my-1 employee_work_info">
                              <Col sm={12} md={6} className="my-1 text-nowrap">
                                <b className="label_Color">{data.data}: </b>
                              </Col>
                              <Col
                                sm={12}
                                md={6}
                                className="my-1 employess_detail_values text-wrap"
                              >
                                <b className="label_value_Color">
                                  {data.value}
                                </b>
                              </Col>
                            </StyledRow>
                          </Col>
                        ))}
                      </Row>
                      <br />
                      <div className="mb-2 d-flex justify-content-between align-items-center">
                        <p className="employee_detail_headings mb-0">
                          {t("Personal Information")}:
                        </p>
                      </div>
                      <Row className="employee_work_info_box">
                        {personalDet.map((data, index) => (
                          <Col xs={12} lg={6} key={index}>
                            <StyledRow className="my-1 employee_work_info">
                              <Col sm={12} md={6} className="my-1 text-wrap">
                                <b className="label_Color">{data.data}: </b>
                              </Col>
                              <Col
                                sm={12}
                                md={6}
                                className="my-1 employess_detail_values text-wrap"
                              >
                                <b className="label_value_Color">
                                  {data?.data === "Terminated File" ? (
                                    <div
                                      className="text-primary"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        if (data?.value !== "-") {
                                          handlepreview(
                                            id,
                                            filteruser?.terminatedfilename
                                          );
                                        }
                                      }}
                                    >
                                      {data.value}
                                    </div>
                                  ) : (
                                    data.value
                                  )}
                                </b>
                              </Col>
                            </StyledRow>
                          </Col>
                        ))}
                      </Row>
                    </>
                  )}
                  {activeTab === "1" && (
                    <>
                      {selectedFolder === null ? (
                        <Wrapper>
                          <Row gutter={[16, 16]}>
                            {folderList.map((item, index) => (
                              <Col
                                xs={12}
                                sm={12}
                                md={6}
                                lg={3}
                                xl={3}
                                key={index}
                              >
                                <Card
                                  className="folder-card"
                                  bordered
                                  onClick={() => setSelectedFolder(item.name)}
                                >
                                  <div className="border-bottom-1">
                                    <FolderFilled className="folder-icon" />
                                  </div>
                                  <div className="folder-title">
                                    {item.name}
                                  </div>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        </Wrapper>
                      ) : (
                        <>
                          <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            aria-label="breadcrumb"
                            className="mb-2"
                          >
                            <label
                              key="2"
                              style={breadStyle}
                              onClick={() => setSelectedFolder(null)}
                            >
                              {t("Back to Folders")}
                            </label>
                            ,
                            <Typography key="3" color="text.primary">
                              {selectedFolder}
                            </Typography>
                          </Breadcrumbs>
                          {selectedFolder === "Identity information" && (
                            <Row className="">
                              <Spin
                                spinning={
                                  isDocumentUpload || isLoadingDocuments
                                }
                              >
                                <StyledTable
                                  className="mb-5 mx-0"
                                  dataSource={IdentityInfoList}
                                  columns={IdentityInfoColumns}
                                  rowClassName={(record, index) =>
                                    index % 2 === 0 ? "" : "non-white"
                                  }
                                  rowKey="role_id"
                                  pagination={
                                    IdentityInfoList.length > 20
                                      ? paginationOptions
                                      : false
                                  }
                                />
                              </Spin>
                            </Row>
                          )}
                          {selectedFolder ===
                            "Final Records on Termination" && (
                            <>
                              {filteruser?.terminatedfilename?.length > 0 ? (
                                <>
                                  <Wrapper>
                                    <Row gutter={[16, 16]}>
                                      {filteruser?.terminatedfilename?.map(
                                        (item, index) => (
                                          <Col
                                            xs={12}
                                            sm={12}
                                            md={6}
                                            lg={3}
                                            xl={3}
                                            key={index}
                                          >
                                            <Card
                                              className="folder-card"
                                              bordered
                                              onClick={() =>
                                                handlepreview(id, item, index)
                                              }
                                            >
                                              <div className="border-bottom-1">
                                                {getFileIcon(item)}
                                              </div>
                                              <div className="folder-title">
                                                {item}
                                              </div>
                                            </Card>
                                          </Col>
                                        )
                                      )}
                                    </Row>
                                  </Wrapper>
                                </>
                              ) : (
                                <Empty />
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {activeTab === "2" && (
                    <>
                      <Row gutter={16}>
                        {filteredCategoriesbygender.map((data) => (
                          <>
                            {leaveData &&
                              leaveData?.find(
                                (item) => item[data?.leave_category_short_name]
                              )?.[data?.leave_category_short_name] && (
                                <Col
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  xl={6}
                                  key={data.leave_category_short_name}
                                >
                                  <Spin spinning={loading}>
                                    <LeaveTrackerChart
                                      iconName={LEAVE_ICON[7]}
                                      title={data.leave_category_name.toUpperCase()}
                                      leaveId={data?.leave_category_id}
                                      leaveTypeName={data?.leave_category_name}
                                      userId={id}
                                      canEdit={canEditLeaveCount}
                                      getUserLeaveData={getUserLeaveData}
                                      data={
                                        leaveData
                                          ?.find(
                                            (item) =>
                                              item[
                                                data?.leave_category_short_name
                                              ]
                                          )
                                          ?.[
                                            data?.leave_category_short_name
                                          ].map((item) => ({
                                            ...item,
                                            color: item.color,
                                            type: item.type,
                                          })) ?? []
                                      }
                                    />
                                  </Spin>
                                </Col>
                              )}
                          </>
                        ))}
                      </Row>
                      <br />
                      <div className="mb-2 d-flex justify-content-between align-items-center">
                        <p className="leave_title_content">
                          {t("Leave Approvals")}:
                        </p>
                        <DatePicker
                          picker="year"
                          value={moment(selectedYear, "YYYY")}
                          onChange={(date, dateString) => {
                            if (dateString) {
                              setSelectedYear(dateString);
                              const startDate = moment(dateString, "YYYY")
                                .startOf("year")
                                .format("YYYY-MM-DD");
                              const endDate = moment(dateString, "YYYY")
                                .endOf("year")
                                .format("YYYY-MM-DD");
                              getLeaveList(startDate, endDate);
                            }
                          }}
                        />
                      </div>
                      <Row className="">
                        <Spin spinning={leaveLoading || loading}>
                          <StyledTable
                            className="mx-0 mb-2"
                            dataSource={LeaveApprovalData}
                            columns={LeaveApprovalColumns}
                            rowClassName={(record, index) =>
                              index % 2 === 0 ? "" : "non-white"
                            }
                            rowKey="role_id"
                            pagination={
                              LeaveApprovalData.length > 20
                                ? paginationOptions
                                : false
                            }
                          />
                        </Spin>
                      </Row>
                      <br />
                      <p className="leave_title_content">
                        {t("Leave History")}:
                      </p>
                      <Row className="">
                        <Spin spinning={leaveLoading || loading}>
                          <StyledTable
                            className="mx-0 mb-5"
                            dataSource={LeaveHistoryData}
                            columns={LeaveHistoryColumns}
                            rowClassName={(record, index) =>
                              index % 2 === 0 ? "" : "non-white"
                            }
                            rowKey="role_id"
                            pagination={
                              LeaveHistoryData.length > 20
                                ? paginationOptions
                                : false
                            }
                          />
                        </Spin>
                      </Row>
                    </>
                  )}
                  {activeTab === "3" && (
                    <>
                      <div className="mb-2 d-flex justify-content-between align-items-center">
                        <b>{t("Education Details")}:</b>
                        {type === "manage" &&
                          Menulist?.find(
                            (item) =>
                              item?.key === "employee" && item?.permission.edit
                          ) && (
                            <ButtonFilled
                              className="px-1"
                              onClick={() => setUpdateState("educationdetails")}
                            >
                              <BorderColorIcon style={iconStyle} />
                            </ButtonFilled>
                          )}
                        {type === "hr" &&
                          Menulist?.find(
                            (item) =>
                              item?.key === "HRResources" &&
                              item?.subMenu?.find(
                                (subItem) =>
                                  subItem?.key === "team" &&
                                  subItem?.permission.edit
                              )
                          ) && (
                            <ButtonFilled
                              className="px-1"
                              onClick={() => setUpdateState("educationdetails")}
                            >
                              <BorderColorIcon style={iconStyle} />
                            </ButtonFilled>
                          )}
                      </div>
                      <StyledTable
                        dataSource={filteruser?.educationdetails}
                        columns={EducationColumns}
                        rowClassName={(record, index) =>
                          index % 2 === 0 ? "" : "non-white"
                        }
                        rowKey="role_id"
                        pagination={false}
                      />

                      <div className="mb-2 d-flex justify-content-between align-items-center">
                        <b>{t("Professional Certification")}:</b>
                        {type === "manage" &&
                          Menulist?.find(
                            (item) =>
                              item?.key === "employee" && item?.permission.edit
                          ) && (
                            <ButtonFilled
                              className="px-1"
                              onClick={() =>
                                setUpdateState("professionalcertifications")
                              }
                            >
                              <BorderColorIcon style={iconStyle} />
                            </ButtonFilled>
                          )}
                        {type === "hr" &&
                          Menulist?.find(
                            (item) =>
                              item?.key === "HRResources" &&
                              item?.subMenu?.find(
                                (subItem) =>
                                  subItem?.key === "team" &&
                                  subItem?.permission.edit
                              )
                          ) && (
                            <ButtonFilled
                              className="px-1"
                              onClick={() =>
                                setUpdateState("professionalcertifications")
                              }
                            >
                              <BorderColorIcon style={iconStyle} />
                            </ButtonFilled>
                          )}
                      </div>
                      <StyledTable
                        dataSource={filteruser?.professionalcertifications}
                        columns={PersenalcertificationColumns}
                        rowClassName={(record, index) =>
                          index % 2 === 0 ? "" : "non-white"
                        }
                        rowKey="role_id"
                        pagination={false}
                      />

                      <div className="mb-2 d-flex justify-content-between align-items-center">
                        <b>{t("Practical Training")}:</b>
                        {type === "manage" &&
                          Menulist?.find(
                            (item) =>
                              item?.key === "employee" && item?.permission.edit
                          ) && (
                            <ButtonFilled
                              className="px-1"
                              onClick={() =>
                                setUpdateState("practicaltrainings")
                              }
                            >
                              <BorderColorIcon style={iconStyle} />
                            </ButtonFilled>
                          )}
                        {type === "hr" &&
                          Menulist?.find(
                            (item) =>
                              item?.key === "HRResources" &&
                              item?.subMenu?.find(
                                (subItem) =>
                                  subItem?.key === "team" &&
                                  subItem?.permission.edit
                              )
                          ) && (
                            <ButtonFilled
                              className="px-1"
                              onClick={() =>
                                setUpdateState("practicaltrainings")
                              }
                            >
                              <BorderColorIcon style={iconStyle} />
                            </ButtonFilled>
                          )}
                      </div>
                      <StyledTable
                        dataSource={filteruser?.practicaltrainings}
                        columns={PracticalTrainingColumns}
                        rowClassName={(record, index) =>
                          index % 2 === 0 ? "" : "non-white"
                        }
                        rowKey="role_id"
                        pagination={false}
                      />
                    </>
                  )}
                  {activeTab === "4" && (
                    <>
                      <div className="mb-2 d-flex justify-content-between align-items-center">
                        <b>{t("Work Experience")}:</b>
                        {type === "manage" &&
                          Menulist?.find(
                            (item) =>
                              item?.key === "employee" && item?.permission.edit
                          ) && (
                            <ButtonFilled
                              className="px-1"
                              onClick={() => setUpdateState("workexperience")}
                            >
                              <BorderColorIcon style={iconStyle} />
                            </ButtonFilled>
                          )}
                        {type === "hr" &&
                          Menulist?.find(
                            (item) =>
                              item?.key === "HRResources" &&
                              item?.subMenu?.find(
                                (subItem) =>
                                  subItem?.key === "team" &&
                                  subItem?.permission.edit
                              )
                          ) && (
                            <ButtonFilled
                              className="px-1"
                              onClick={() => setUpdateState("workexperience")}
                            >
                              <BorderColorIcon style={iconStyle} />
                            </ButtonFilled>
                          )}
                      </div>
                      <StyledTable
                        className="mb-5"
                        dataSource={filteruser?.workexperience}
                        columns={wrokExperenceColumns}
                        rowClassName={(record, index) =>
                          index % 2 === 0 ? "" : "non-white"
                        }
                        rowKey="role_id"
                        pagination={false}
                      />
                    </>
                  )}
                  {activeTab === "5" && (
                    <div className="text-center">
                      <h2>{t("Page under Construction")}</h2>
                    </div>
                  )}
                </TabPane>
              ))}
            </Tabs>
          </StyledProfileDetails>

          <StyledModal
            title={t("Profile Picture")}
            open={showImageModal}
            onCancel={() => {
              CloseImageModal();
              resetSelectedImage();
            }}
            confirmLoading={confirmLoading}
            footer={[
              <ButtonOutlined
                key="cancel"
                onClick={() => {
                  CloseImageModal();
                  resetSelectedImage();
                }}
              >
                {t("Cancel")}
              </ButtonOutlined>,
              <ButtonFilled
                key="save"
                onClick={() => {
                  handleUploadProfile();
                }}
                loading={confirmLoading}
              >
                {t("Set")}
              </ButtonFilled>,
            ]}
          >
            {selectedImage ? (
              <div>
                <AvatarEditor
                  ref={editorRef}
                  image={objectUrl}
                  width={200}
                  height={200}
                  border={50}
                  color={[255, 255, 255, 0.6]}
                  scale={zoomin}
                  rotate={rotatein}
                  borderRadius={250}
                />
                <div className="editor_div">
                  <label>{t("Zoom")}:</label>
                  <Slider
                    defaultValue={zoomin}
                    onChange={setZoomin}
                    min={1}
                    max={20}
                  />
                </div>
                <div className="editor_div">
                  <label>{t("Rotate")}:</label>
                  <Slider
                    defaultValue={rotatein}
                    onChange={setRotatein}
                    min={0}
                    max={360}
                  />
                </div>
                <MainStyledDropzone onDrop={handleDrop} />
              </div>
            ) : (
              <MainStyledDropzone onDrop={handleDrop} />
            )}
          </StyledModal>

          {/* Confirmation Modal */}
          <StyledNewModal
            title={t("Terminating!")}
            open={open}
            onCancel={handleCancel}
            footer={null}
          >
            <div className="content_style">
              {t(
                "On terminating the employee, their access to company resources will be revoked and their performance cannot be tracked."
              )}
              <br></br>
              <br></br>
              {t("Are you sure you want to terminate this employee?")}
            </div>
            <Form
              form={form}
              layout="vertical"
              initialValues={{}}
              onFinish={(values) => {
                handleSubmitForm(values);
              }}
              className="mt-2"
            >
              <Form.Item
                label={t("Reason for termination")}
                name="terminatereason"
                rules={[
                  {
                    required: true,
                    message: t("Reason for termination is required"),
                  },
                  { max: 250, message: t("Max 250 chars") },
                ]}
              >
                <TextArea rows={3} maxLength={250} />
              </Form.Item>
              <div className="text-end">
                <ButtonOutlined key="cancel" onClick={handleCancel}>
                  {t("Cancel")}
                </ButtonOutlined>
                <ButtonFilled
                  key="save"
                  type="primary"
                  htmlType="submit"
                  // onClick={handleOk}
                  disabled={!form.getFieldValue("terminatereason")}
                  loading={btnLoader}
                >
                  {t("Yes")}, {t("Terminate")}
                </ButtonFilled>
              </div>
            </Form>
          </StyledNewModal>

          {/* Termination Details Modal */}
          <StyledNewModal
            title={
              <div
                style={{ fontSize: "16px", fontWeight: 600, color: "#111827" }}
              >
                {t("Terminating!")}
              </div>
            }
            open={openTerminationmodal}
            onCancel={handleCanceltermination}
            footer={null}
          >
            <div className="outer_row">
              <Form form={form} layout="vertical" initialValues={{}}>
                {/* Final Clearance */}
                <Form.Item
                  label={
                    <span>
                      {t("Final Clearance")}{" "}
                      <Tooltip
                        title={t("Select all clearance items completed")}
                      >
                        <InfoCircleOutlined style={{ color: "#1d4ed8" }} />
                      </Tooltip>
                    </span>
                  }
                  name="clearance"
                >
                  <Checkbox.Group
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0px",
                    }}
                    onChange={(checkedValues) =>
                      setCheckedClearance(checkedValues)
                    }
                  >
                    <div
                      style={{
                        borderBottom: "1px solid #f0f0f0",
                        paddingBottom: "10px",
                        paddingTop: "4px",
                      }}
                    >
                      <Checkbox value="Network access revoked">
                        {t("Network access revoked")}
                      </Checkbox>
                    </div>
                    <div
                      style={{
                        borderBottom: "1px solid #f0f0f0",
                        paddingBottom: "10px",
                        paddingTop: "10px",
                      }}
                    >
                      <Checkbox value="Email Access revoked">
                        {t("Email Access revoked")}
                      </Checkbox>
                    </div>
                    <div style={{ paddingTop: "10px" }}>
                      <Checkbox value="others">{t("Others")}</Checkbox>
                    </div>
                  </Checkbox.Group>
                </Form.Item>

                {/* Tag input shown when "Others" is checked */}
                {checkedClearance?.includes("others") && (
                  <Form.Item name="otherTags">
                    <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder={t("Type and press enter...")}
                      open={false}
                      suffixIcon={null}
                    />
                  </Form.Item>
                )}

                {/* Final Employee Records */}
                <Form.Item
                  label={t("Final Employee Records")}
                  name="attachment"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => e?.fileList}
                >
                  <Upload
                    beforeUpload={() => false}
                    multiple
                    showUploadList={false}
                    onChange={(e) => {
                      form.setFieldsValue({ attachment: e.fileList });
                      setAttachmentList(e.fileList); // 👈 sync state
                    }}
                  >
                    {/* Show uploaded files as tags */}
                    {attachmentList?.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                          marginBottom: "8px",
                          width: "100%",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {attachmentList?.map((file, index) => (
                          <Tag
                            key={index}
                            closable
                            onClose={(e) => {
                              e.stopPropagation();
                              const updated = attachmentList.filter(
                                (_, i) => i !== index
                              );
                              setAttachmentList(updated);
                              form.setFieldsValue({ attachment: updated });
                            }}
                            style={{
                              padding: "4px 8px",
                              borderRadius: "6px",
                              fontSize: "13px",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              background: "#fff",
                              border: "1px solid #d9d9d9",
                            }}
                          >
                            {file.name}
                          </Tag>
                        ))}
                      </div>
                    )}

                    {/* Upload Button */}
                    <Button
                      icon={<UploadOutlined />}
                      style={{
                        width: "100%",
                        background: "#eef2ff",
                        border: "none",
                        color: "#1d4ed8",
                        fontWeight: 500,
                      }}
                    >
                      {t("Upload File")}
                    </Button>
                  </Upload>
                </Form.Item>

                {/* Notes */}
                <Form.Item
                  label={t("Notes (if any)")}
                  name="notes"
                  rules={[{ max: 250, message: t("Max 250 chars") }]}
                >
                  <TextArea
                    rows={4}
                    maxLength={250}
                    showCount={{
                      formatter: () => "Maximum 250 characters",
                    }}
                  />
                </Form.Item>

                {/* Footer Buttons */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 8,
                  }}
                >
                  <ButtonOutlined
                    onClick={() => {
                      form.resetFields();
                      setCheckedClearance([]);
                      setAttachmentList([]);
                      handleCanceltermination();
                    }}
                  >
                    {t("Cancel")}
                  </ButtonOutlined>
                  <ButtonFilled
                    type="primary"
                    htmlType="submit"
                    loading={btnLoader}
                    style={{ background: "#1d4ed8", borderColor: "#1d4ed8" }}
                    onClick={() => {
                      setOpenTerminationmodal(false);
                      setOpen(true);
                    }}
                  >
                    {t("Terminate")}
                  </ButtonFilled>
                </div>
              </Form>
            </div>
          </StyledNewModal>

          <Modal
            title={t("Approve leave")}
            open={isModalOpen}
            onOk={approveHandleOk}
            onCancel={approveHandleCancel}
            footer={[
              <Button key="back" onClick={approveHandleCancel}>
                {t("No")}
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={approveHandleOk}
              >
                {t("Yes")}
              </Button>,
            ]}
          >
            <p>{t("Are you sure you want to approve leave?")}</p>
          </Modal>

          <RejectReasonModal
            isOpenModal={displayDeclineReasonModal}
            closeModal={closeDeclineReasonModal}
          />
        </>
      )}

      {updateState && (
        <EditProfile
          updateState={updateState}
          setUpdateState={setUpdateState}
          EmployeeDetails={EmployeeDetails}
          pageName="Employee"
        />
      )}

      <StyledDocumentModal
        centered={true}
        visible={isPreviewModalOpen}
        footer={false}
        keyboard={false}
        width="100%"
        height="100vh"
        onOk={() => setIsPreviewModalOpen(false)}
        onCancel={() => setIsPreviewModalOpen(false)}
      >
        <Spin spinning={isLoadingDocuments}>
          {previewType === "jpg" ||
          previewType === "png" ||
          previewType === "jpeg" ||
          previewType === "svg" ? (
            <div className="img">
              <img src={previewURL} className="img_fit" alt="Preview" />
            </div>
          ) : (
            <embed
              title="PDF Viewer"
              src={previewURL}
              type="application/pdf"
              width="100%"
              height="600px"
              className="pdf-viewer-embed px-5"
            />
          )}
        </Spin>
      </StyledDocumentModal>
      <ViewDocument
        open={preview}
        onCancel={() => {
          setPreview(false);
          setPreviewURL("");
        }}
        data={previewURL}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  userList: getUserList(state),
  ClientId: getClientid(state),
  departmentList: getAllDepartmentList(state),
  locationList: getLocations(state),
  roleList: getRoleList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  userInfo: getUserInfo(state),
  leaveCategoryList: getLeaveCategoryList(state),
  menuList: getMenuList(state),
  userRoleId: getUserRoleId(state),
  departmentList: getAllDepartmentList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUserList: setUserList,
      saveProfilePic: setProfilePic,
      saveRoleList: setRoleList,
    },
    dispatch
  );

const StyledNewModal = styled(Modal)`
  .ant-modal-close-x {
    display: none;
  }
  .ant-modal-title {
    color: #1f243b !important;
    font-size: 18px;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
  }
  .ant-modal-body {
    padding: 0px 17px 30px 24px;
  }
  .ant-modal-header {
    border-bottom: none !important;
    border-radius: 40px 40px 0 0;
  }
  .ant-modal-content {
    border-radius: 10px;
  }
  .ant-modal-footer {
    border-top: none !important;
  }
  .content_style {
    color: #636980;
    font-family: "DM Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }
  .ant-upload {
    width: 100% !important;
    display: block !important;
  }
`;

const StyledDocumentModal = styled(Modal)`
  height: 100vh;
  max-width: 80rem;
  padding: 1%;
  width: 100%;
  .ant-modal-content {
    height: 100vh;
    width: 100%;
    box-shadow: none;
  }
  .img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    max-height: 80rem;
    transform: scale(0.85);
  }
  .iframe {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100vh;
    transform: scale(0.85);
  }
  .file_fit {
    width: 100%;
    height: 100%;
  }
  .img_fit {
    max-width: 80vw;
    max-height: 100vh;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-close-x {
    display: none;
  }
  .ant-modal-header {
    border-bottom: none !important;
    border-radius: 40px 40px 0 0;
  }
  .ant-modal-footer {
    border-top: none !important;
  }
  .ant-modal-content {
    border-radius: 10px;
  }
  .modal {
    display: flex;
    justify-content: center;
    border-radius: 10px;
  }
  .ant-modal-body > div:first-child {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .editor_div {
    width: 75%;
  }
`;

const StyledProfileDetails = styled.div`
  .terminate {
    margin-left: 20px !important;
  }
  .Icon_style {
    font-size: "20px";
  }
  .StyledImage {
    background-color: white;
    vertical-align: middle;
  }
  .ant-badge .ant-scroll-number-custom-component {
    transform: translate(0%, 0%) !important;
    bottom: 0px !important;
    top: 89px;
  }
  .styled_col {
    display: flex;
    align-items: center;
    @media (max-width: 428px) {
      flex-direction: column;
    }
  }
  .camera_select_icon {
    font-size: 22px;
  }
  .camera_select_icon rect {
    fill: #1890ff;
  }
  .Remove_select_icon {
    margin-left: -10px !important;
    margin-right: 6px !important;
    margin-top: -2px !important;
  }
  .Edit_select_icon {
    height: 30px !important;
    width: 29px !important;
    margin-left: -10px !important;
    margin-top: -2px !important;
  }
  .Edit_select_icon rect {
    fill: none;
  }
  .leave_approval_actions {
    display: flex;
    gap: 10px;
  }
  .leave_tracker_container {
    width: 100%;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 4px 27px 0px #00000017;
    border-radius: 14px;
  }
  .leave_tracker_chart {
    display: flex;
    gap: 1rem;
    @media (max-width: 890px) {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
    }
  }
  .css-1ps7utq {
    margin-bottom: 0 !important;
  }
  .employee_work_info_box {
    width: 100%;
    margin: auto;
    padding: 10px;
    box-shadow: 0px 3px 6px #00000015;
    background: #ffffff 0% 0% no-repeat padding-box;
  }
  .employess_detail_values {
    text-wrap: nowrap;
  }
  .info_identity_container {
    width: 100%;
    margin: auto;
  }
  .personal_details_box {
    width: 100%;
    margin: auto;
    background: #ffffff 0% 0% no-repeat padding-box;
  }
  .employee_work_info {
    border-bottom: 1px solid #f8f8f8;
  }
  .employess_detail_summary {
    display: flex;
    flex-direction: column;
  }
  .employee_detail_headings {
    font-family: "DM Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #1f243b;
    margin-left: 10px;
  }
  .leave_title_content {
    font-family: "DM Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #1f243b;
  }
  .Broker_profile_flex {
    align-items: center;
    padding: 2rem;
    border-radius: 5px;
  }
  .broker_tittle {
    font-family: "DM Sans", sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
  }
  .common_color_style {
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #636980;
    margin-top: 5px;
  }
  .contact_details {
    display: flex;
    gap: 0.6rem;
    text-wrap: wrap;
    p {
      margin-bottom: 0rem;
    }
  }
  .leave_approval_actions {
    display: flex;
    gap: 10px;
  }
  .credit_box_container {
    text-align: end;
    // display: flex;
    // justify-content: end;
    // gap: 0.8rem;
    // padding-right: 0;
    @media (max-width: 900px) {
      // display: flex;
      // flex-direction: column;
      // align-items: center;
    }
  }
  .ant-tabs-nav-wrap {
    border-bottom: 2px solid #e2e2e8;
    color: #636980 !important;
  }
  .ant-tabs-tab-active {
    font-family: "DM Sans", sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.3019;
  }
  .ant-tabs-ink-bar {
    background-color: #000;
  }
  .ant-tabs-tab {
    color: #636980;
    font-family: "DM Sans", sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 20.83px;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #000;
  }
  @media (min-width: 320px) and (max-width: 767px) {
    .employess_detail_values {
      text-wrap: wrap;
    }
  }
`;

const StyledTable = styled(Table)`
  padding: 0;
  margin-bottom: 0;
  table {
    table-layout: auto !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #e2e2e8;
    border-radius: 8px;
  }
  .ant-table-cell {
    height: 50px;
  }
  .ant-table-thead .ant-table-cell {
    font-family: "DM Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #1f243b;
  }
  .ant-table-tbody > tr > td {
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3019;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .non-white {
    background: #f9f9f9;
  }
  .normal-column {
    white-space: normal;
  }
`;

const StyledAvatar = styled(Avatar)`
  font-size: 3rem;
  height: 120px;
  width: 120px;
  background-color: ${COLORS.PRIMARY};
  vertical-align: middle;
  color: #fff;
  .ant-avatar-string {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const StyledRow = styled(Row)`
  width: 100%;
  display: flex;
  justify-content: center;
  .my-1 {
    display: flex;
    word-wrap: break-word;
  }
  .label_Color {
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3019;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .label_value_Color {
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #1f243b;
  }
`;
const Wrapper = styled.div`
  padding: 20px;

  .folder-card {
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s;
    text-align: center;
    height: 140px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
      transform: translateY(-3px);
    }
  }

  .folder-icon {
    font-size: 48px;
    color: #f5b400;
    margin-bottom: 10px;
  }

  .folder-title {
    font-size: 14px;
    color: #333;
  }
`;

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDetails);
